import { FC } from 'react'
import { Link, LinkProps } from '../../compass-ui'

const BlankTargetLink: FC<LinkProps> = (props) => (
  <Link target="_blank" rel="noreferrer" {...props} />
)

export default BlankTargetLink
